const CollectionFilterBrandsDialog = (el) => {
  let onClose = null;

  const initialize = () => {
    el.querySelector(".fs-dialog-backdrop").addEventListener("click", () => {
      onClose(null);
      el.classList.remove("show");
    });
    el.querySelector(".fs-close-button").addEventListener("click", () => {
      onClose(null);
      el.classList.remove("show");
    });
    el.querySelector(".fs-clear-button").addEventListener("click", () => {
      el.querySelectorAll("input[type=checkbox]").forEach((input) => {
        input.checked = false;
      });
      onClose([]);
      el.classList.remove("show");
    });
    el.querySelector(".fs-select-button").addEventListener("click", () => {
      const brands = [];
      el.querySelectorAll("input[type=checkbox]").forEach((input) => {
        if (input.checked) {
          brands.push(input.value);
        }
      });
      onClose(brands);
      el.classList.remove("show");
    });

    el.querySelectorAll(".fs-brand-menu-abc-header-item").forEach((itemEl) => {
      itemEl.addEventListener("click", (e) => {
        const title = e.target.dataset.title;
        const mode = e.target.dataset.mode;
        const container = el.querySelector(".fs-dialog-content");
        const target = container.querySelector(`.fs-item[data-title="${title}"`);
        const containerRect = container.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const top = targetRect.top + container.scrollTop - 48 - 52 - 48 - containerRect.top;
        container.scrollTo({ top: top, behavior: "smooth" });
      });
    });
  };

  const show = (selectedBrands, onCloseFunc) => {
    el.classList.add("show");
    el.querySelectorAll("input[type=checkbox]").forEach((input) => {
      input.checked = selectedBrands.includes(input.value);
    });
    onClose = onCloseFunc;
  };

  initialize();

  return {
    show: show,
  };
};

export default CollectionFilterBrandsDialog;
